/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query ContactBookDirectoryReadUniqueQuery($contactBookDirectoryId: ID!) {
  ContactBookDirectoryReadUnique(contactBookDirectoryId: $contactBookDirectoryId) {
    id,
    displayName,
    message,
    status
  }
}
`
